import React from "react";

export default function RFQQuoteEntryGrid({
  lines = [],
  setLines
}) {

  const handleChange = (
    index,
    field,
    value
  ) => {

    const updated = [...lines];

    updated[index] = {
      ...updated[index],
      [field]: value
    };

    const rate =
      Number(
        updated[index].quoted_price || 0
      );

    const tax =
      Number(
        updated[index].tax_amount || 0
      );

    updated[index].total_amount =
      rate + tax;

    setLines(updated);
  };

  return (

    <div className="rfq-table-wrapper">

      <table className="rfq-table">

        <thead>
          <tr>
            <th>Material</th>
            <th>Qty</th>
            <th>UOM</th>
            <th>Rate Per Unit</th>
            <th>Tax</th>
            <th>Total</th>
            <th>Delivery Days</th>
            <th>Payment Terms</th>
            <th>Remarks</th>
          </tr>
        </thead>

        <tbody>

          {lines.map((line, index) => (

            <tr key={line.rfq_line_id}>

              <td>
                {line.material_name}
              </td>

              <td>
                {line.qty}
              </td>

              <td>
                {line.uom}
              </td>

              <td>
                <input
                  type="number"
                  value={
                    line.quoted_price || 0
                  }
                  onChange={(e) =>
                    handleChange(
                      index,
                      "quoted_price",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  value={
                    line.tax_amount || 0
                  }
                  onChange={(e) =>
                    handleChange(
                      index,
                      "tax_amount",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                {Number(
                  line.total_amount || 0
                ).toFixed(2)}
              </td>

              <td>
                <input
                  type="number"
                  value={
                    line.delivery_days || ""
                  }
                  onChange={(e) =>
                    handleChange(
                      index,
                      "delivery_days",
                      e.target.value
                    )
                  }
                />
              </td>
              <td>
                <input
                    type="text"
                    value={
                    line.payment_terms || ""
                    }
                    onChange={(e) =>
                    handleChange(
                        index,
                        "payment_terms",
                        e.target.value
                    )
                    }
                />
                </td>

                <td>
                <input
                    type="text"
                    value={
                    line.remarks || ""
                    }
                    onChange={(e) =>
                    handleChange(
                        index,
                        "remarks",
                        e.target.value
                    )
                    }
                />
                </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}